import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { createTTL } from '@backmarket/utils/date/createTTL'

const COOKIE_EXPIRATION_DATE = 6

export function createConfig() {
  const { market } = useMarketplace()
  const expirationDate = createTTL({ months: COOKIE_EXPIRATION_DATE }).getTime()

  return {
    domain: market.domain,
    expires: new Date(expirationDate),
  }
}
